import { get, set } from 'idb-keyval';
import Vue from 'vue';
import Vuex from 'vuex';
import APICache from './lib/api-cache';
import api from './services/api';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    syncing: false,
    online: true,
    /** @type {{route: string, version: Date}[]} */
    routes: [],

    views: undefined,
  },

  mutations: {
    online(state) { state.online = true; },
    offline(state) { state.online = false },

    syncing(state, status) { state.syncing = status },

    save(state, data) {
      let views = state.views;
      if (!views) views = {};
      if (!views[data.view]) views[data.view] = {};
      views[data.view] = { ...views[data.view], ...data.attributes };
      state.views = views;
    }
  },

  actions: {
    async sync({ state, commit }) {
      try {
        if (state.syncing) return;
        commit('syncing', true);

        const now = new Date();
        let updateNow = true;

        const response = await api.get('/offline-sync');
        const { error, errors, routes } = response.data;

        if (error) {
          console.log("sync:", errors);
        } else {
          for (const route of routes) {
            try {
              const cached = await get(route.url);
              let result;

              if (!cached)
                result = await APICache.fetch(route.url);
              else if (!cached.version)
                result = await APICache.fetch(route.url);
              else if (new Date(route.version) > new Date(cached.version))
                result = await APICache.fetch(route.url);
              else continue;

              if (result.data.error) updateNow = false;
              else await APICache.cache(result.config.url, route.type, result.data);

            } catch (err) {
              updateNow = false;
            }
          }

          if (updateNow) await set('last-offline-update', now.toJSON());
        }

        commit('syncing', false);
      } catch (error) {
        console.log("sync:", error);
      }
    }
  }
});

export default store;